module.exports = __webpack_public_path__ + "img/facebook.cbe4fcb4.svg";